import { render } from "./index.vue?vue&type=template&id=385dec2d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=385dec2d&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=385dec2d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-385dec2d"

export default script